<template>
  <div class="flex gap-2">
    <el-button @click="loadDialog">
      {{ selectedFile?.name || t('selectFile') }}
    </el-button>
  </div>
  <el-dialog v-model="showDialog">
    <div class="flex flex-col gap-4">
      <div>
        <div v-if="selectedFile?.url" class="font-bold">{{t('selectedFile')}}</div>
        <div class="flex gap-2">
          <ul v-if="selectedFile?.url" class="el-upload-list el-upload-list--picture-card">
            <li class="el-upload-list__item">
              <img :src="settingsStore.storagePath + '/' + selectedFile?.name" alt="selected image" width="150" class="el-upload-list__item-thumbnail"/>
              <label class="el-upload-list__item-status-label"></label>
            </li>
          </ul>
          <el-upload
              class="w-[200px]"
              drag
              :action="settingsStore.baseUrl + '/storage/files'"
              :on-success="loadFiles"
              :on-error="showError"
              :http-request="handleUpload"
          >
            <div class="m-[17px] text-xl">
              <el-icon>
                <Plus/>
              </el-icon>
            </div>
          </el-upload>
        </div>

      </div>
      <div v-if="files.length">
        <div class="font-bold">{{t('files')}}</div>
        <ul class="el-upload-list el-upload-list--picture-card">
          <li :key="i" v-for="(file, i) in files" class="el-upload-list__item"
              :class="{'is-success': selectedFile == file}">
            <img class="el-upload-list__item-thumbnail"
                 :src="settingsStore.storagePath + '/' + file.name" alt="">
            <label class="el-upload-list__item-status-label">
            </label>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview">
                 <el-icon @click="() => {selectFile(file)}">
                  <Select/>
                </el-icon>
               </span>
              <span class="el-upload-list__item-delete">
                 <el-icon @click="() => {handleRemove(file)}">
                  <Delete/>
                </el-icon>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>

  </el-dialog>
</template>
<script setup lang="ts">
import {useHTTP} from "@/plugins/http";
import {onMounted, ref} from "vue";
import {Delete, Plus, Select} from '@element-plus/icons-vue'
import type {
  UploadFile, UploadFiles,
  UploadRequestOptions,
  UploadUserFile
} from 'element-plus'
import {useI18n} from "vue-i18n";
import {useSettingsStore} from "@/stores/settingsStore";
import { ElMessage } from 'element-plus'

const props = defineProps(['modelValue'])
const emits = defineEmits(['change'])

const { t } = useI18n({
  messages: {
    en: {
      selectFile: 'Select File',
      selectedFile: 'Selected File',
      files: 'Files',
    },
    ar: {
      selectFile: 'أختر ملف',
      selectedFile: 'الملف المختار',
      files: 'الملفات',
    }
  }
})


const http = useHTTP()

const showDialog = ref(false);
const selectedFile = ref<UploadUserFile|null>();
const files = ref<Array<UploadUserFile>>([]);
const settingsStore = useSettingsStore();

onMounted(() => {
  loadFiles();
});

function loadFiles() {
  http.get<any>('/storage/files').then(resp => {
    if (resp) {
      files.value = resp.map(i => {
        return {
          name: i.name,
          url: settingsStore.storagePath + '/' + i.name,
        }
      })

      const searchFiles = files.value.filter(f => f.name == props.modelValue)
      if (searchFiles.length) {
        selectedFile.value = searchFiles[0];
      }
    } else {
      files.value = [];
    }

  })
}

function handleRemove(uploadFile: any) {
  http.delete(settingsStore.baseUrl + '/storage/files/' + uploadFile.name!).then(resp => {
    if (uploadFile.url == selectedFile.value?.url) {
      selectedFile.value = null;
    }
    loadFiles();
  })
}

function handleUpload(options: UploadRequestOptions) {
  const data = new FormData();
  data.set('file', options.file)
  return http.post(options.action, data)
}

function selectFile(file: any) {
  selectedFile.value = file;
  showDialog.value = false;
  emits('change', file)
}


function loadDialog() {
  showDialog.value = true;
}

function showError (error: any, uploadFile: UploadFile, uploadFiles: UploadFiles) {
  ElMessage({
    showClose: true,
    message: error?.title,
    type: 'error',
  })
}

</script>
<style scoped>

</style>
